import { render, staticRenderFns } from "./NextPageTrigger.vue?vue&type=template&id=13a48995&scoped=true&lang=pug&"
import script from "./NextPageTrigger.vue?vue&type=script&lang=js&"
export * from "./NextPageTrigger.vue?vue&type=script&lang=js&"
import style0 from "./NextPageTrigger.vue?vue&type=style&index=0&id=13a48995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a48995",
  null
  
)

export default component.exports